module.exports = __webpack_public_path__ + "img/h_s1e1_gallery_2.4fccb3b1.png";